import styles from "./Testimonials.module.css";
import Reveal from "./Reveal";
import Icon from "./Icons";
import TestimonialForm from "./TestimonialForm";
import useTestimonials from "../hooks/useTestimonials";
import useSiteSettings from "../hooks/useSiteSettings";
import { isFirebaseConfigured } from "../firebase";

/**
 * Always renders (unlike the earlier static version) once Firebase is
 * configured — the section's job now includes inviting a submission,
 * not just displaying ones that already exist. Before Firebase is
 * configured it renders nothing, matching the previous behaviour.
 */
export default function Testimonials() {
  const { testimonials, loading } = useTestimonials();
  const { doctor } = useSiteSettings();

  if (!isFirebaseConfigured) return null;

  return (
    <section className={`u-section ${styles.section}`}>
      <div className="u-shell">
        <Reveal className={styles.head}>
          <p className="u-eyebrow">Patient stories</p>
          <h2 className={styles.heading}>In their words.</h2>
        </Reveal>

        <div className={styles.layout}>
          <div className={styles.listCol}>
            {loading && (
              <p className={styles.status}>Loading testimonials…</p>
            )}

            {!loading && testimonials.length === 0 && (
              <p className={styles.status}>
                No testimonials yet — be the first to leave one.
              </p>
            )}

            <ul className={styles.grid}>
              {testimonials.map((t, i) => (
                <Reveal
                  as="li"
                  key={t.id}
                  delay={Math.min(i, 3) * 80}
                  className={styles.card}
                >
                  <span className={styles.quoteMark} aria-hidden="true">
                    &ldquo;
                  </span>
                  <blockquote className={styles.quote}>{t.quote}</blockquote>
                  <footer className={styles.meta}>
                    <span className={styles.name}>{t.name}</span>
                    <span className={styles.context}>
                      {[t.context, t.area].filter(Boolean).join(" · ")}
                    </span>
                  </footer>
                </Reveal>
              ))}
            </ul>

            {doctor.profiles.google && (
              <a
                className={styles.reviewsLink}
                href={doctor.profiles.google}
                target="_blank"
                rel="noopener noreferrer"
              >
                Read more reviews on Google
                <Icon name="arrow" size={17} />
              </a>
            )}
          </div>

          <div className={styles.formCol}>
            <TestimonialForm />
          </div>
        </div>
      </div>
    </section>
  );
}
